import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const commands = [
  ['Dashboard', '/dashboard'],
  ['Analytics', '/dashboard/analytics'],
  ['Projects', '/dashboard/projects'],
  ['Design system', '/dashboard/design-system'],
  ['Inbox', '/dashboard/inbox'],
  ['Team', '/dashboard/team'],
  ['Settings', '/dashboard/settings'],
] as const;

export function CommandPalette({ open, onClose }: { open: boolean; onClose: () => void }) {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const filtered = useMemo(
    () => commands.filter(([label]) => label.toLowerCase().includes(query.trim().toLowerCase())),
    [query],
  );

  useEffect(() => {
    if (!open) setQuery('');
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <div className="command-palette" onMouseDown={(e) => e.stopPropagation()}>
        <div className="command-input"><span>⌕</span><input autoFocus value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search commands…" /></div>
        <div className="command-group">
          <small>Navigate</small>
          {filtered.length ? filtered.map(([label, path]) => (
            <button key={path} onClick={() => { void navigate(path); onClose(); }}>
              <span>{label}</span><kbd>↵</kbd>
            </button>
          )) : <div className="empty-state compact"><span>No matching commands.</span></div>}
        </div>
      </div>
    </div>
  );
}
